module.exports = require("./../../_gen/openfl/events/NetStatusEvent");